import { render } from "./SessionChat.vue?vue&type=template&id=09a942d0&scoped=true&ts=true"
import script from "./SessionChat.vue?vue&type=script&lang=ts"
export * from "./SessionChat.vue?vue&type=script&lang=ts"

import "./SessionChat.vue?vue&type=style&index=0&id=09a942d0&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a942d0"]])

export default __exports__